import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import HomePage2 from "../../main-component/HomePage2/HomePage2";
import TaniltsuulgaPage from "../../main-component/TaniltsuulgaPage/TaniltsuulgaPage";
import SaindurZadargaaPage from "../../main-component/SaindurZadargaa/SaindurZadargaaPage";
import SainDurPage from "../../main-component/SainDurPage/Saindur";
import DotoodSurgaltPage from "../../main-component/DotoodSurgaltPage/DotoodSurgaltPage";
import DotoodSurgaltZadargaa from "../../main-component/DotoodSurgaltZadargaa/DotoodSurgaltZadargaaPage";
import TsuglaanPage from "../../main-component/TsuglaanPage/TsuglaanPage";
import StorySinglePage from "../../main-component/StorySinglePage/StorySinglePage";
import TeamPage from "../../main-component/TeamPage/TeamPage";
import TeamSinglePage from "../../main-component/TeamSinglePage/TeamSinglePage";
import MedeelelPage from "../../main-component/MedeelelPage/MedeelelPage";
import ShopPage from "../../main-component/ShopPage/ShopPage";
import ProductSinglePage from "../../main-component/ProductSinglePage/ProductSinglePage";
import CartPage from "../../main-component/CartPage/CartPage";
import CheckoutPage from "../../main-component/CheckoutPage/CheckoutPage";
import ServicePage from "../../main-component/ServicePage/ServicePage";
import ServiceSinglePage from "../../main-component/ServiceSinglePage/ServiceSinglePage";
import UrlagSportPage from "../../main-component/Urlag-sport/UrlagSportPage";
import HolbooBarihPage from "../../main-component/Holboobarih/HolbooBarihPage";
import MedeeDetails from "../MedeeDetails/MedeeDetails";
import Aldaa404 from "../../main-component/404/404";
import AmjiltPage from "../../main-component/AmjiltPage/Amjilt";

const AnimatedAllRoute = ({ isDark, onToggleDark }) => {
  // console.log("🎥 AnimatedAllRoute isDark:", isDark);

  const location = useLocation();
  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={<HomePage2 isDark={isDark} onToggleDark={onToggleDark} />}
        />
        <Route
          path="taniltsuulga"
          element={
            <TaniltsuulgaPage isDark={isDark} onToggleDark={onToggleDark} />
          }
        />
        <Route
          path="dotood-ua"
          element={
            <DotoodSurgaltPage isDark={isDark} onToggleDark={onToggleDark} />
          }
        />
        <Route
          path="dotood-ua/:slug"
          element={
            <DotoodSurgaltZadargaa
              isDark={isDark}
              onToggleDark={onToggleDark}
            />
          }
        />
        <Route
          path="tsuglaan"
          element={<TsuglaanPage isDark={isDark} onToggleDark={onToggleDark} />}
        />
        <Route
          path="urlag-sport"
          element={
            <UrlagSportPage isDark={isDark} onToggleDark={onToggleDark} />
          }
        />
        <Route
          path="sain-dur"
          element={<SainDurPage isDark={isDark} onToggleDark={onToggleDark} />}
        />
        <Route
          path="sain-dur/:slug"
          element={
            <SaindurZadargaaPage isDark={isDark} onToggleDark={onToggleDark} />
          }
        />
        <Route
          path="medee-medeelel"
          element={<MedeelelPage isDark={isDark} onToggleDark={onToggleDark} />}
        />
        <Route
          path="medee-medeelel/:slug"
          element={<MedeeDetails isDark={isDark} onToggleDark={onToggleDark} />}
        />
        <Route
          path="bidentei-holbogdoh"
          element={
            <HolbooBarihPage isDark={isDark} onToggleDark={onToggleDark} />
          }
        />
        <Route
          path="bidnii-amjilt"
          element={<AmjiltPage isDark={isDark} onToggleDark={onToggleDark} />}
        />

        <Route
          path="*"
          element={<Aldaa404 isDark={isDark} onToggleDark={onToggleDark} />}
        />

        <Route path="volunteers" element={<TeamPage />} />
        <Route path="team-single/:slug" element={<TeamSinglePage />} />
        <Route path="products" element={<ShopPage />} />
        <Route path="product-single/:slug" element={<ProductSinglePage />} />
        <Route path="cart" element={<CartPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="service" element={<ServicePage />} />
        <Route path="service-single/:slug" element={<ServiceSinglePage />} />
        <Route path="story-details/:slug" element={<StorySinglePage />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedAllRoute;
